import React, { ReactNode, useContext, useEffect, useState } from 'react';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { VulnerabilitySummary } from '@totem/components/vulnerabilities/overviewSummary/types';
import VulnerabilitySummaryContext from '@totem/components/vulnerabilities/overviewSummary/vulnerabilitySummaryContext';
import { Params } from '@totem/types/common';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  children?: ReactNode;
};
const DeviceVulnerabilitySummaryContainer = ({ children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<VulnerabilitySummary>(null);
  useEffect(() => {
    setLoading(true);
    const params: Params = {
      paging: {
        page: 1,
        pageSize: 10000,
      },
      sort: {
        field: '',
        direction: -1,
      },
      filters: [],
    };
    fetch(`${DEVICES_ENDPOINT}/vulnerabilities`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((result: VulnerabilitySummary) => {
        setData(result);
      })
      .then(() => {
        setLoading(false);
      });
  }, [userProfile.organization.id, getApiToken]);
  return (
    <VulnerabilitySummaryContext.Provider
      value={{
        data,
        loading,
      }}
    >
      {children}
    </VulnerabilitySummaryContext.Provider>
  );
};
export default DeviceVulnerabilitySummaryContainer;
